const state = () => ({
  DataBusForStudent: {
    provinceBus: "50",
    districtBus: "",
    localityBus: "",
  },
  DataFrom6: {
    tes_id: "",
    stu_card_id: "",

    stu_sub_relation: "",
    stu_sub_prename: "",
    stu_sub_fname: "",
    stu_sub_lname: "",
    stu_shomeid: "",
    stu_svillage: "",
    stu_ssoi: "",
    stu_sroad: "",
    stu_sprovince: "",
    stu_sdistrict: "",
    stu_slocality: "",
    stu_spostcode: "",
    stu_sphone: "",
    stu_sms: "",
    stu_sub_occ: "",
    stu_sub_mon: "",
    stu_sub_plan: "",
    stu_sub_phoneplan: "",

    date_appointment: "",

    select_year: "",
  },
  DataPrename: [],
  DataProvince: [],
  DataDistrict: [],
  DataLocality: [],
  DataOccupationNew: [],
  SetStep6: [],
  DataCheckBayAll: [],
  qrcodeChkStatusPay: [],
  DatafinanceBillNoti: [],
  DataDatedateConf: [],
  DataStudentTest: [],
  DataStudent_Test: [],
  DataClass: [],
  DataDepartmentStu: [],
  DataBorrowStu: [],
  DataSignupPayManual: [],
  Datasecret_test: [],
  DataVersion: [],
  DataStutest_Follow: [],
  DataSubDepartmentStu: [],
  DataDistrictBus: [],
  DataLocalityBus: [],
  listBusForStudent: [],
  DataProvinceBus: [],
});
/* ========== getters ========== */
const getters = {
  _getDataFrom6: (state) => {
    return state.DataFrom6;
  },
  _getDataBusForStudent: (state) => {
    return state.DataBusForStudent;
  },
  _getDataprename: (state) => {
    return state.DataPrename;
  },
  _getDataProvince: (state) => {
    return state.DataProvince;
  },
  _getDataDistrict: (state) => {
    return state.DataDistrict;
  },
  _getDataLocality: (state) => {
    return state.DataLocality;
  },
  _getDataOccupationNew: (state) => {
    return state.DataOccupationNew;
  },
  _SetStep6: (state) => {
    return state.SetStep6;
  },
  _getqrcodeChkStatusPay: (state) => {
    return state.qrcodeChkStatusPay;
  },
  _getfinanceBillNoti: (state) => {
    return state.DatafinanceBillNoti;
  },
  _getDataDatedateConf: (state) => {
    return state.DataDatedateConf;
  },
  _getDataStudentTest: (state) => {
    return state.DataStudentTest;
  },
  _getDataStudent_Test: (state) => {
    return state.DataStudent_Test;
  },
  _getDataClass: (state) => {
    return state.DataClass;
  },
  _getDataDepartmentStu: (state) => {
    return state.DataDepartmentStu;
  },
  _getDataBorrowStu: (state) => {
    return state.DataBorrowStu;
  },
  _getDataSignupPayManual: (state) => {
    return state.DataSignupPayManual;
  },
  _getDataVersion: (state) => {
    return state.DataVersion;
  },
  _getDatasecret_test: (state) => {
    return state.Datasecret_test;
  },
  _getDataStutestFollow: (state) => {
    return state.DataStutest_Follow;
  },
  _getDataSubDepartmentStu: (state) => {
    return state.DataSubDepartmentStu;
  },
  _getDataDistrictBus: (state) => {
    return state.DataDistrictBus;
  },
  _getDataLocalityBus: (state) => {
    return state.DataLocalityBus;
  },
  _getlistBusForStudent: (state) => {
    return state.listBusForStudent;
  },
  _getDataProvinceBus: (state) => {
    return state.DataProvinceBus;
  },
};
/* ========== actions ========== */
const actions = {
  async SetStepStatus({ state, rootState }) {
    // ======================== เบิกวันที่ปัจจุบันผ่าน APIs ========================
    try {
      const response = await window.Axios.post(
        `${window.api}exec/GetStepStatus6/`,
        state.DataFrom6
      );
      rootState.Main.DataStep6 = response.data;
    } catch (error) {
      console.error(error);
    }
  },
  async SetStep6({ state }) {
    // ======================== เบิกวันที่ปัจจุบันผ่าน APIs ========================
    try {
      let data = {
        tes_id: state.DataFrom6.tes_id,
      };
      const response = await window.Axios.post(
        `${window.api}post/GetStep6/`,
        data
      );
      state.SetStep6 = response.data;

      const statSet6 = state.SetStep6;
      const From6 = state.DataFrom6;

      if (state.SetStep6 != "") {
        statSet6.stu_sub_relation
          ? (From6.stu_sub_relation = statSet6.stu_sub_relation.trim())
          : "";
        statSet6.stu_sub_prename
          ? (From6.stu_sub_prename = statSet6.stu_sub_prename.trim())
          : "";
        statSet6.stu_sub_fname
          ? (From6.stu_sub_fname = statSet6.stu_sub_fname.trim())
          : "";
        statSet6.stu_sub_lname
          ? (From6.stu_sub_lname = statSet6.stu_sub_lname.trim())
          : "";
        statSet6.stu_shomeid
          ? (From6.stu_shomeid = statSet6.stu_shomeid.trim())
          : "";
        statSet6.stu_svillage
          ? (From6.stu_svillage = statSet6.stu_svillage.trim())
          : "";
        statSet6.stu_ssoi ? (From6.stu_ssoi = statSet6.stu_ssoi.trim()) : "";
        statSet6.stu_sroad ? (From6.stu_sroad = statSet6.stu_sroad.trim()) : "";
        statSet6.stu_sprovince
          ? (From6.stu_sprovince = statSet6.stu_sprovince.trim())
          : "";
        From6.stu_sdistrict = statSet6.stu_sdistrict;
        From6.stu_slocality = statSet6.stu_slocality;
        statSet6.stu_spostcode
          ? (From6.stu_spostcode = statSet6.stu_spostcode.trim())
          : "";
        statSet6.stu_sphone
          ? (From6.stu_sphone = statSet6.stu_sphone.trim())
          : "";
        statSet6.stu_sms ? (From6.stu_sms = statSet6.stu_sms.trim()) : "";
        statSet6.stu_sub_occ
          ? (From6.stu_sub_occ = statSet6.stu_sub_occ.trim())
          : "";
        statSet6.stu_sub_mon == ".00" || statSet6.stu_sub_mon == null
          ? (From6.stu_sub_mon = "0")
          : (From6.stu_sub_mon = statSet6.stu_sub_mon.trim().split(".")[0]);
        statSet6.stu_sub_plan
          ? (From6.stu_sub_plan = statSet6.stu_sub_plan.trim())
          : "";
        statSet6.stu_sub_phoneplan
          ? (From6.stu_sub_phoneplan = statSet6.stu_sub_phoneplan.trim())
          : "";
      }
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataPrename({ commit }) {
    try {
      const response = await window.Axios.get(`${window.api}get/Getprename/`);
      await commit("GET_DataPrename", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataProvince({ commit }) {
    try {
      const response = await window.Axios.get(`${window.api}get/GetProvince/`);
      await commit("GET_DataProvince", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataSubDepartmentStu({ commit }) {
    try {
      const response = await window.Axios.get(
        `${window.api}get/GetSubDepartmentStu/`
      );
      await commit("GET_DataSubDepartmentStu", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async POST_DataDistrict({ commit, state }) {
    try {
      const response = await window.Axios.post(
        `${window.api}post/GetDistrictParent/`,
        state.DataFrom6
      );
      await commit("POST_DataDistrict", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async POST_DataDistrictBus({ commit, state }) {
    try {
      const data = { provinceBus: state.DataBusForStudent.provinceBus };
      const response = await window.Axios.post(
        `${window.api}post/postDataDistrictBus/`,
        data
      );
      await commit("POST_DataDistrictBus", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async POST_DataLocalityBus({ commit, state }) {
    try {
      const data = {
        stu_province: state.DataBusForStudent.provinceBus,
        stu_district: state.DataBusForStudent.districtBus,
      };
      const response = await window.Axios.post(
        `${window.api}post/GetLocalityD/`,
        data
      );
      await commit("POST_DataLocalityBus", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async POST_DataLocality({ commit, state }) {
    try {
      const response = await window.Axios.post(
        `${window.api}post/GetLocalityParent/`,
        state.DataFrom6
      );
      await commit("POST_DataLocality", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataOccupationNew({ commit }) {
    try {
      const response = await window.Axios.get(
        `${window.api}get/GetOccupationNew/`
      );
      await commit("GET_DataOccupationNew", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async POST_DatafinanceBillNoti({ state, commit }) {
    try {
      const response = await window.Axios.post(
        `${window.api}post/GetfinanceBillNoti/`,
        state.DataFrom6
      );
      await commit("POST_DatafinanceBillNoti", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async SET_qrcodeChkStatusPay({ state, commit }) {
    try {
      const response = await window.Axios.post(
        `${window.api}exec/GetqrcodeChkStatusPay/`,
        state.DataFrom6
      );
      await commit("SET_qrcodeChkStatusPay", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async SET_DatedateConf({ state, commit }) {
    try {
      const response = await window.Axios.post(
        `${window.api}exec/GetDatedateConf/`,
        state.DataFrom6
      );
      await commit("SET_DatedateConf", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async POST_StudentTest({ state, commit }) {
    try {
      const response = await window.Axios.post(
        `${window.api}post/GetStudentTest/`,
        state.DataFrom6
      );
      await commit("POST_StudentTest", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async POST_Student_Test({ state, commit }) {
    try {
      const response = await window.Axios.post(
        `${window.api}post/GetStudent_Test/`,
        state.DataFrom6
      );
      await commit("POST_Student_Test", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataClass({ commit }) {
    try {
      const response = await window.Axios.get(`${window.api}get/GetClass/`);
      await commit("GET_DataClass", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataDepartmentStu({ commit }) {
    try {
      const response = await window.Axios.get(
        `${window.api}get/GetDepartmentStu/`
      );
      await commit("GET_DataDepartmentStu", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataBorrowStu({ commit, state }) {
    try {
      const response = await window.Axios.post(
        `${window.api}post/GetBorrowStu/`,
        state.DataFrom6
      );
      await commit("GET_DataBorrowStu", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataSignupPayManual({ commit }) {
    try {
      const response = await window.Axios.get(
        `${window.api}get/GetSignupPayManual/`
      );
      await commit("GET_DataSignupPayManual", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async GET_Signup_date({ commit }) {
    try {
      const response = await window.Axios.get(
        `${window.api}get/GetSignup_date/`
      );
      await commit("GET_Signup_date", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async GET_Version({ commit }) {
    try {
      const response = await window.Axios.get(`${window.api}get/GetVersion/`);
      await commit("GET_Version", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataProvinceBus({ commit }) {
    try {
      const response = await window.Axios.get(
        `${window.api}get/getDataProvinceBus/`
      );
      await commit("GET_DataProvinceBus", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async POST_secret_test({ state, commit }) {
    try {
      const response = await window.Axios.post(
        `${window.api}post/Getsecret_test/`,
        state.DataFrom6
      );
      await commit("POST_secret_test", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async POST_DataBusForStudent({ state, commit }) {
    try {
      const response = await window.Axios.post(
        `${window.api}post/postDataBusForStudentAndNameDriver/`,
        state.DataBusForStudent
      );
      await commit("POST_DataBusForStudent", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async SET_Stutest_Follow({ state, commit }) {
    try {
      const response = await window.Axios.post(
        `${window.api}exec/GetStutestFollow/`,
        state.DataFrom6
      );
      await commit("SET_Stutest_Follow", response.data);
    } catch (error) {
      console.error(error);
    }
  },
};

/* ========== mutations ========== */
const mutations = {
  GET_DataPrename(state, payload) {
    state.DataPrename = payload;
  },
  GET_DataProvince(state, payload) {
    state.DataProvince = payload;
  },
  POST_DataDistrict(state, payload) {
    state.DataDistrict = payload;
  },
  POST_DataDistrictBus(state, payload) {
    state.DataDistrictBus = payload;
  },
  POST_DataLocalityBus(state, payload) {
    state.DataLocalityBus = payload;
  },
  POST_DataLocality(state, payload) {
    state.DataLocality = payload;
  },
  GET_DataOccupationNew(state, payload) {
    state.DataOccupationNew = payload;
  },
  SET_qrcodeChkStatusPay(state, payload) {
    state.qrcodeChkStatusPay = payload;
  },
  POST_DatafinanceBillNoti(state, payload) {
    state.DatafinanceBillNoti = payload;
  },
  SET_DatedateConf(state, payload) {
    state.DataDatedateConf = payload;
  },
  POST_StudentTest(state, payload) {
    state.DataStudentTest = payload;
  },
  POST_Student_Test(state, payload) {
    state.DataStudent_Test = payload;
  },
  GET_DataClass(state, payload) {
    state.DataClass = payload;
  },
  GET_DataDepartmentStu(state, payload) {
    state.DataDepartmentStu = payload;
  },
  GET_DataBorrowStu(state, payload) {
    state.DataBorrowStu = payload;
  },
  GET_DataSignupPayManual(state, payload) {
    state.DataSignupPayManual = payload;
  },
  GET_Signup_date(state, payload) {
    state.DataSignup_date = payload;
  },
  GET_Version(state, payload) {
    state.DataVersion = payload;
  },
  POST_secret_test(state, payload) {
    state.Datasecret_test = payload;
  },
  POST_DataBusForStudent(state, payload) {
    state.listBusForStudent = payload;
  },
  SET_Stutest_Follow(state, payload) {
    state.DataStutest_Follow = payload;
  },
  GET_DataSubDepartmentStu(state, payload) {
    state.DataSubDepartmentStu = payload;
  },
  GET_DataProvinceBus(state, payload) {
    state.DataProvinceBus = payload;
  },
};

/* ========== Export ========== */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
